/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Empty_MentionsInputs */

const en_notifications_empty_mentions = /** @type {(inputs: Notifications_Empty_MentionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No mentions yet.`)
};

const pt_br2_notifications_empty_mentions = /** @type {(inputs: Notifications_Empty_MentionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma menção ainda.`)
};

/**
* | output |
* | --- |
* | "No mentions yet." |
*
* @param {Notifications_Empty_MentionsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_empty_mentions = /** @type {((inputs?: Notifications_Empty_MentionsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Empty_MentionsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_empty_mentions(inputs)
	return pt_br2_notifications_empty_mentions(inputs)
});